import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('orcfacil_token');
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      api.get('/auth/me')
        .then(res => setUser(res.data))
        .catch(() => { localStorage.removeItem('orcfacil_token'); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('orcfacil_token', res.data.access_token);
    api.defaults.headers.common['Authorization'] = `Bearer ${res.data.access_token}`;
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (data) => {
    const res = await api.post('/auth/register', data);
    localStorage.setItem('orcfacil_token', res.data.access_token);
    api.defaults.headers.common['Authorization'] = `Bearer ${res.data.access_token}`;
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('orcfacil_token');
    delete api.defaults.headers.common['Authorization'];
    setUser(null);
  };

  const refreshUser = async () => {
    const res = await api.get('/auth/me');
    setUser(res.data);
    return res.data;
  };

  const isTrialExpired = () => {
    if (!user) return false;
    if (user.subscription_status === 'active') return false;
    if (user.is_admin) return false;
    if (user.trial_end) {
      return new Date() > new Date(user.trial_end);
    }
    return false;
  };

  const trialDaysLeft = () => {
    if (!user?.trial_end) return 0;
    const diff = new Date(user.trial_end) - new Date();
    return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
  };

  const canCreate = () => {
    if (!user) return false;
    if (user.is_admin) return true;
    if (user.subscription_status === 'active') return true;
    if (user.subscription_status === 'trial' && user.trial_end) {
      return new Date() < new Date(user.trial_end);
    }
    return false;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser, isTrialExpired, trialDaysLeft, canCreate }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
